import { PRICING_CALCULATOR_FIELDS } from '@shared/schema/pricingCalculator.js';

const resolvePricingCalculatorDefaults = ({ saved } = {}) => {
  return Object.fromEntries(
    PRICING_CALCULATOR_FIELDS.map((field) => {
      const savedValue = saved?.[field.key];
      return [field.key, typeof savedValue === 'number' && Number.isFinite(savedValue) ? savedValue : field.seed];
    })
  );
};

export default resolvePricingCalculatorDefaults;
